import { Component, OnInit } from '@angular/core'
import { BaseListing } from '../_base-listing/base-listing'
import { ListingItem } from 'depoto-core/src/models'
import { CoreService } from '../../services'
import { Checkout } from 'depoto-core/src/entities'
import { checkoutsColumns } from '../../utils/definitions.util'

const DEFAULT_FILTERS = {
  visible: false,
  expanded: false,
  name: '',
  sortProp: 'name',
  sortDir: 'asc',
}

@Component({
  selector: 'app-checkouts',
  templateUrl: 'checkouts.component.html',
})
export class CheckoutsComponent extends BaseListing implements OnInit {
  listingColumns: ListingItem[] = checkoutsColumns
  checkouts: Checkout[] = []
  totalItems = 0
  currentPage: number
  endPage: number
  filters = DEFAULT_FILTERS
  canCreate = false
  loading = true
  constructor(protected core: CoreService) {
    super(core)
    this.getStorageKey('checkouts')
  }

  ngOnInit() {
    this.filters = this.loadViewSettings('checkouts') || DEFAULT_FILTERS
    if (this.core.services.user.user) {
      this.checkPerms()
    }
    this.core.services.user.currentUserEmitter.subscribe().then(() => {
      this.checkPerms()
    })
    this.filter()
  }

  checkPerms() {
    this.canCreate =
      this.core.services.user.hasRole('ROLE_CHECKOUT_CREATE') || this.core.services.user.hasRole('ROLE_SUPER_ADMIN')
  }

  clearFilters(): void {
    this.filters.name = ''
    this.filter(1)
  }

  filter(pageNo = 1, sortProp: string = this.sortProp, sortDir: string = this.sortDir, concat = false): void {
    const options: any = {}
    this.currentPage = pageNo
    if (this.filters && this.filters.name && this.filters.name.length > 0) {
      options.name = this.filters.name
    }
    this.loading = true
    if (!concat) {
      this.reloading = true
    }
    this.core.services.checkout
      .getList(
        { page: pageNo, sort: sortProp, direction: sortDir, filters: options },
        {
          id: null,
          name: null,
        },
      )
      .then(result => {
        this.loading = false
        this.reloading = false
        if (!concat) {
          this.checkouts = result.items
        } else {
          result.items.forEach(checkout => {
            this.checkouts.push(new Checkout(checkout))
          })
        }
        this.totalItems = result.paginator ? result.paginator.totalCount : 0
        this.endPage = result.paginator ? result.paginator.endPage : 0
        this.saveViewSettings('checkouts', this.filters)
      })
  }
}
